<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Banners Ads</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container-fluid">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-10">
            <div class="isotope-wrapper">
              <div class="box_general padding_bottom">
                <form @submit.prevent="searchbanner()" method="post">
                  <div class="row">
                    <div class="col-md-12 add_top_30">
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Expire Date</label>
                            <date-picker
                              v-model="search.expire_date"
                              :config="datepickerconfig"
                            ></date-picker>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Location</label>
                             <vue-simple-suggest
                            v-model="search.location"
                            display-attribute="name"
                            value-attribute="url"
                            :list="getSuggestionList"
                          ></vue-simple-suggest>
                          <a href="javascript:void(0);" @click="currentLoc()"
                           >Use My Current Location</a
                             >
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Pincode</label>
                            <input
                              class="form-control"
                              type="number"
                              v-model="search.pincode"
                            />
                          </div>
                        </div>
                        <div class="col-lg-5">
                          <label>Categories</label>
                          <select2-multiple-control
                            :options="catOptions"
                            :settings="{
                              multiple: true,
                            }"
                            multiple
                            @select="catSelectEvent($event)"
                          />
                        </div>

                        <div class="col-lg-5">
                          <label>Sub Categories</label>
                          <select2-multiple-control
                            :options="subCatOptions"
                            :settings="{ multiple: true }"
                            @select="subcatselectEvent($event)"
                            placeholder="-Select Categories-"
                          />
                        </div>
                        <div class="col-lg-2">
                          <button type="submit" class="btn_1 add_top_30 mb-4">
                            Search
                          </button>
                        </div>

                        <div class="col-lg-12">
                          <router-link
                            class="btn_1 add_top_30 mb-4"
                            to="banner-ads"
                            >Create Banner</router-link
                          >
                        </div>
                      </div>

                      <!-- /row-->
                      <table
                        class="table table-striped table-bordered table-sm"
                        cellspacing="0"
                        width="100%"
                        id="table"
                      >
                        <thead>
                          <tr>
                            <th>Sr No</th>
                            <th>Category</th>
                            <th>Banner</th>
                            <th>Location</th>
                            <th>Pincode</th>
                            <th>Validity</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(banner, index) in banners"
                            :key="banner.id"
                          >
                            <th>{{ index + 1 }}</th>
                            <td>
                              <div
                                v-for="categories in banner.banner_categories"
                                :key="categories.id"
                              >
                                <span class="badge badge-success">{{
                                  categories.category
                                }}</span>
                              </div>
                            </td>
                            <td>
                              <img
                                :src="`https://peekzy.in/backend/public/assets/user/vendorbanner/${banner.banner_image}`"
                                style="width: 100%"
                                class="mt-1"
                              />
                            </td>
                            <td>
                              <strong>{{ banner.location }}</strong>
                            </td>
                            <td>
                              <strong>{{ banner.pincode }}</strong>
                            </td>
                            <td>
                              <strong>{{
                                frontEndDateFormat(banner.expire_date)
                              }}</strong>
                            </td>
                            <td
                              class="options"
                              style="width: 5%; text-align: center"
                            >
                              <a
                                href="javascript:void(0); "
                                @click="redirect(banner.id, 'update-banner')"
                                v-show="banner.status == 0"
                                ><i class="fa fa-pencil"></i> </a
                              >&nbsp;&nbsp;
                              <a
                                href="javascript:void(0); "
                                @click="redirect(banner.id, 'delete-offer')"
                                v-show="banner.status == 2"
                                ><i class="fa fa-trash"></i
                              ></a>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- /row-->
                      <!-- /row-->
                    </div>
                  </div>
                </form>
              </div>
              <!-- /row -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
// import axios from 'axios'
import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import moment from "moment";
import $ from "jquery";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";

export default {
  data() {
    return {
      roleId: localStorage.getItem("role_id"),
      token: "Bearer " + localStorage.getItem("token"),
      msg: null,
      classAlert: null,
      profileDetails: [],
      catOptions: [],
      subCatOptions: [],
      banners: [],
      search: {
        expire_date: "",
        location: "",
        pincode: "",
      },
      searchcat: {
        categories: [],
        subcategories: [],
      },
      datepickerconfig: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        minDate: new Date(),
        maxDate: new Date().setMonth(new Date().getMonth() + 1),
      },
      galleryimage: [],
      login_id: null,
      files: [],
    };
  },
  components: {
    Frontendlayout,
    Sidebar,
    VueSimpleSuggest
  },
  beforeMount() {
    this.checkToken();
    this.getParentCategories();
    this.getbanner();
  },
  watch: {
    banners(val) {
      console.log(val);
      this.dt.destroy();

      this.$nextTick(() => {
        this.dt = $(".table").DataTable();
      });
    },
  },

  methods: {
    redirect(offerId, route) {
      let i = window.btoa(offerId);
      this.$router.push(`${route}/${i}`);
    },
     getSuggestionList () {
      var i =[]
      var config = {
    headers: {
    'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
}
}
      if (this.search.location.length >= 2) {
       return API.get(`https://location.securebrandtech.com/auto/api?q=${this.search.location}`,config)
          .then(function (response) {
        response.data.features.forEach(function (feature) {
            i.push(`${feature.properties.name} ${feature.properties.state} ${feature.properties.country} ${feature.properties.postcode?feature.properties.postcode:feature.properties.countrycode}`) 
            })
            var uniq = [ ...new Set(i) ];
            return uniq 
            
          })

          .catch(function (error) {
            console.log(error);
          });
      }
    },
     currentLoc() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition)
      } else {
        this.error = 'Geolocation is not supported.'
      }
    },
   showPosition(position){
  position.coords.latitude
  position.coords.longitude
  var location = [position.coords.latitude,position.coords.longitude]
  this.SuggestionList(location)
      
   }, 
   SuggestionList(location){
      var i = [];
      // if (this.search.location.length >= 2) {
         API.get(`https://location.securebrandtech.com/auto/api?q=india&lat=${location[0]}&lon=${location[1]}`
        )
          .then( (response)=> {
            response.data.features.forEach(function (feature) {
              i.push(
                feature.properties.name +
                  " " +
                  feature.properties.county?feature.properties.county:"" +
                  " " +
                  " " +
                  feature.properties.state?feature.properties.state:"" +
                  " " +
                  feature.properties.postcode?feature.properties.postcode:""
              );
            });
            var uniq = [...new Set(i)];
            this.search.location = uniq[1]        
          })

          .catch(function (error) {
            console.log(error);
          });
 },
    checkToken() {
      //alert(this.token);
      if (this.token == "Bearer " + null) {
        this.$router.push("/signin");
      }
    },
    getParentCategories() {
      API.get("categories/parent_services_select2list")
        //.get("categories/parent_services")
        .then((res) => {
          this.catOptions = res.data.data;
          // this.search = this.search.categories;
          console.log(res.data.data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    setSubCategory(categoryId, mode) {
      //alert(categoryId);
      // let selSubCat = this.search.subcategories;
      API.get(
        "categories/parent_services_select2list/" + window.btoa(categoryId)
      )
        //.get("categories/parent_services")
        .then((res) => {
          if (mode == "push") {
            res.data.data.forEach((val) => {
              console.log("val=" + JSON.stringify(val));
              this.subCatOptions.push(val);
              //this.subCatOptions.concat(res.data.data);
            });

            //console.log("sub cat options=" + this.subCatOptions);
          } else {
            //this.search.subcategories.push(res.data.data);
            res.data.data.forEach((val) => {
              this.subCatOptions.splice(this.subCatOptions.indexOf(val.id), 1);
            });
          }
          this.searchcat.subcategories = [];
          // this.emitFilterRequest();
          //this.loadNearbyOffers(this.search);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    catSelectEvent(e) {
      var sel = e.selected;
      if (sel) {
        this.setSubCategory(e.id, "push");
        this.searchcat.categories.push(e.id);
      } else {
        this.setSubCategory(e.id, "remove");
        this.searchcat.categories.splice(
          this.searchcat.categories.indexOf(e.id),
          1
        );
      }
    },
    subcatselectEvent(e) {
      var sel = e.selected;
      //alert(sel + " " + e.id + " " + e.text + " " + e.selected);
      if (sel) {
        this.searchcat.subcategories.push(e.id);
      } else {
        this.searchcat.subcategories.splice(
          this.searchcat.subcategories.indexOf(e.id),
          1
        );
      }
      //this.loadNearbyOffers(this.search);
    },
    frontEndDateFormat(date) {
      //alert(moment(date, "YYYY-MM-DD").format("DD-MM-YYYY"));
      return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
    },
    backEndDateFormat: function (date) {
      return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    },
 getAddressData: function (addressData, placeResultData, id) {
        this.search.location = addressData;
        console.log(placeResultData)
        console.log(id)
      },
    searchbanner() {
      const form = new FormData();
      form.append("search", JSON.stringify(this.search));
      form.append("categories", JSON.stringify(this.searchcat.categories));
      form.append(
        "subcategories",
        JSON.stringify(this.searchcat.subcategories)
      );
      API.post("/Banner/search", form, {
        headers: { Authorization: this.token },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.dt = $("#table").DataTable();

            setTimeout(() => (this.banners = res.data.data));
          } else {
            this.dt = $("#table").DataTable();
            this.banners = res.data.data;
          }
        })
        .catch((err) => {
          this.msg = err.response.data.messages.error;
          setTimeout(() => {
            this.msg = "";
          }, 3000);
          this.classAlert = "danger";
        });
      //axios
    },
    onGalleryChange() {
      this.files = this.$refs.file.files;
    },
    getbanner() {
      // alert(this.token);
      const role_id = localStorage.getItem("role_id");
      const form = new FormData();
      form.append("role_id", role_id);
      API.post("/Banner/get_banner_by_vendorId", form, {
        headers: { Authorization: this.token },
      })
        .then((res) => {
          this.dt = $(".table").DataTable();

          setTimeout(() => (this.banners = res.data.data));
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    createImage(file) {
      this.image = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    mounted() {
      this.getbanner();
      this.$refs.address.focus();
    },
  },
};
</script>
<style  scoped>
@import "../../public/frontend/vendor/dropzone.css";

.show_img,
.header_box img {
  width: 100%;
}
</style>